module.exports = __webpack_public_path__ + "static/media/portrait12.6eb1ec7a.jpg";